import React from 'react';
import Sidebar from '../components/Sidebar';
import DashboardNavbar from '../components/DashboardNavbar';
import PackageTable from '../components/PackageTable';

const Packages = () => {
  return (
    <div className="d-flex entire-bg-color">
      <Sidebar />

      <div className="flex-grow-1">
        <DashboardNavbar />
        <div style={{ marginTop: '70px' }}></div>

        <PackageTable />


      </div>
    </div>
  );
};

export default Packages;